import { Moment } from "moment";
import { AppThunk, AppDispatch } from "../../types";
import fetchReport from "../../../shared/fetchReport";

type FetchBilledAdsLwtdProps = {
  startDate: Moment;
  endDate: Moment;
  report: string;
};
export type FetchBilledAdsLwtd = (filters: FetchBilledAdsLwtdProps) => void;

const fetchBilledAdsLwtd = ({
  startDate,
  endDate,
  report
}: FetchBilledAdsLwtdProps): AppThunk => async (dispatch: AppDispatch) => {
  const params = {
    start_date: startDate.format("YYYY-MM-DD"),
    end_date: endDate.format("YYYY-MM-DD"),
  };
  await fetchReport(report, dispatch, params);
};

export default fetchBilledAdsLwtd;
